import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronDoubleRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-double-right"><path d="M14 16L18 12L14 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7 16L11 12L7 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChevronDoubleRight;
